export default __webpack_public_path__ + "static/joko-app-screenshot-home-en@2x-bc5ef3e81307c015a34fec93514a6b18.png";